import {createBrowserRouter} from "react-router-dom";
import Home from "../views/Home";
import React from "react";
import Cart from "../views/Cart";
import Summary from "../views/Summary";
import Creator from "../views/Creator";

export const router = createBrowserRouter([
    {
        path: "/",
        element: (<Home />),
    },
    {
        path: "/cart",
        element: (<Cart />),
    },
    {
        path: "/contact",
        element: (<Summary />),
    },
    {
        path: "/configurator",
        element: (<Creator />),
    },
]);